import React from "react";

import { getWindow } from "@thelabnyc/thelabui/src/utils/dom";

interface IProps {
    desktop_image?: string;
    mobile_image?: string;
}

export const OrderOfferImage = (props: IProps): React.ReactNode => {
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const window = getWindow();
        if (!window) {
            return;
        }
        const handleResize = () => {
            if (window.innerWidth <= 500) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const backgroundImage = isMobile ? props.mobile_image : props.desktop_image;

    return (
        <div
            style={{ backgroundImage: `url('${backgroundImage}')` }}
            className="thank-you-order-offer__container"
        ></div>
    );
};
